import { render, staticRenderFns } from "./EnderecosExternosTab.vue?vue&type=template&id=ed3f27be&scoped=true&"
import script from "./EnderecosExternosTab.vue?vue&type=script&lang=js&"
export * from "./EnderecosExternosTab.vue?vue&type=script&lang=js&"
import style0 from "./EnderecosExternosTab.vue?vue&type=style&index=0&id=ed3f27be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3f27be",
  null
  
)

export default component.exports